import { render, staticRenderFns } from "./RedesignTag.vue?vue&type=template&id=548ca3e2&scoped=true"
import script from "./RedesignTag.vue?vue&type=script&setup=true&lang=js"
export * from "./RedesignTag.vue?vue&type=script&setup=true&lang=js"
import style0 from "./RedesignTag.vue?vue&type=style&index=0&id=548ca3e2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548ca3e2",
  null
  
)

export default component.exports